import { Injectable } from '@angular/core';

import { LoggerService, PolicyService } from '@campfire-nx/api';

@Injectable({
  providedIn: 'root',
})
export class OdoReadingService {
  constructor(
    private policyService: PolicyService,
    private loggerService: LoggerService
  ) { }

  getOdoReading(uuid: string) {
    return this.policyService.getOdoBySlug(uuid)
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        this.loggerService.error('OdoReadingService', 'getOdoReading', {
          error: error
        });

        return Promise.reject(error);
      });
  }

  create(uuid: string, reading: number) {
    return this.policyService.create(uuid, reading)
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        this.loggerService.error('OdoReadingService', 'create', {
          error: error
        });

        return Promise.reject(error);
      });
  }
}
